import { useCurrentUser } from 'hooks/auth';

import { CURRENCY_SIGN_MAP } from '@libs/ui/components/job/utils/common';

export const useCurrentTalentCurrency = () => {
  const { getData } = useCurrentUser();
  const currency = getData()?.data?.currentTalent?.currency;

  return currency;
};

export const useCurrentTalentCurrencySymbol = () => {
  const currency = useCurrentTalentCurrency();
  const currencySymbol = currency ? CURRENCY_SIGN_MAP[currency] : '$';

  return currencySymbol;
};
